import * as React from "react";
import { forwardRef } from "react";
const SvgSelected = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 12c0 .621.504 1.125 1.125 1.125h6.563c.103 0 .187.084.187.188v6.562a1.125 1.125 0 0 0 2.25 0v-6.563c0-.103.084-.187.188-.187h6.562a1.125 1.125 0 0 0 0-2.25h-6.563a.187.187 0 0 1-.187-.188V4.125a1.125 1.125 0 0 0-2.25 0v6.563a.187.187 0 0 1-.188.187H4.125C3.504 10.875 3 11.379 3 12z" }));
const ForwardRef = forwardRef(SvgSelected);
export { ForwardRef as ReactComponent };
